import {
  GetWorkspaceKeyValuesForPrebidVariableQuery,
  GetWorkspaceKeyValuesForPrebidVariableQueryVariables,
} from 'gql/graphql'

import { useAbility } from 'providers/casl'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { PS_VARIABLE_KEY_VALUE_NAME } from '../../constants'
import { GET_WORKSPACE_KEY_VALUES_FOR_PREBID_VARIABLE } from './api/query'

type UseIsPsVariableKeyValueCreated = {
  isPsVariableKeyValueCreated: boolean
  loading: boolean
}

type WorkspaceKeyValueSlice =
  GetWorkspaceKeyValuesForPrebidVariableQuery['workspaceKeyValues'][number]

export const useIsPsVariableKeyValueCreated = (): UseIsPsVariableKeyValueCreated => {
  const ability = useAbility()

  const { data, isLoading } = useQuery<
    GetWorkspaceKeyValuesForPrebidVariableQueryVariables,
    GetWorkspaceKeyValuesForPrebidVariableQuery,
    boolean
  >({
    options: {
      enabled: ability.can('read', 'GlobalSetupField-prebidVariableName'),
      select: ({ workspaceKeyValues }: GetWorkspaceKeyValuesForPrebidVariableQuery): boolean =>
        workspaceKeyValues.some(
          (workspaceKeyValue: WorkspaceKeyValueSlice): boolean =>
            workspaceKeyValue.keyValue.name === PS_VARIABLE_KEY_VALUE_NAME &&
            workspaceKeyValue.status === 'created',
        ),
    },
    query: GET_WORKSPACE_KEY_VALUES_FOR_PREBID_VARIABLE,
  })

  return {
    isPsVariableKeyValueCreated: data ?? false,
    loading: isLoading,
  }
}
